module.exports = __webpack_public_path__ + "img/showgototime.aa120a12.png";